(function () {
  'use strict';

  /* ---------------- Cart drawer ---------------- */

  function openDrawer() {
    var el = document.querySelector('[data-cart-drawer]');
    if (el) el.classList.add('is-open');
  }
  function closeDrawer() {
    var el = document.querySelector('[data-cart-drawer]');
    if (el) el.classList.remove('is-open');
  }

  function updateFragment(html, selector) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var newEl = doc.querySelector(selector);
    if (!newEl) return;
    document.querySelectorAll(selector).forEach(function (el) {
      el.innerHTML = newEl.innerHTML;
    });
  }

  async function refreshCartFragments() {
    try {
      var res = await fetch(window.location.pathname + '?sections=cart-drawer,main-cart');
      var data = await res.json();
      updateFragment(data['cart-drawer'], '[data-cart-drawer-body]');
      updateFragment(data['main-cart'], '[data-cart-page-body]');
    } catch (e) { /* noop */ }
    updateCartCount();
  }

  async function updateCartCount() {
    try {
      var res = await fetch('/cart.js');
      var cart = await res.json();
      document.querySelectorAll('.cart-link').forEach(function (el) {
        el.textContent = 'Cart (' + cart.item_count + ')';
      });
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
      });
    } catch (e) { /* noop */ }
  }

  async function addToCart(variantId, quantity, properties) {
    var body = { items: [{ id: variantId, quantity: quantity || 1 }] };
    if (properties) body.items[0].properties = properties;
    var res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
    if (!res.ok) {
      var err = await res.json().catch(function () { return {}; });
      throw new Error(err.description || 'Could not add to cart');
    }
    await refreshCartFragments();
    openDrawer();
  }

  async function changeLineQty(key, quantity) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    });
    await refreshCartFragments();
  }

  async function reorderItems(items) {
    var res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    });
    if (!res.ok) {
      var err = await res.json().catch(function () { return {}; });
      throw new Error(err.description || 'Could not reorder');
    }
    await refreshCartFragments();
    window.location.href = '/cart';
  }

  document.addEventListener('click', function (e) {
    var reorderBtn = e.target.closest('[data-reorder]');
    if (reorderBtn) {
      e.preventDefault();
      var items;
      try { items = JSON.parse(reorderBtn.getAttribute('data-reorder')); } catch (err) { items = []; }
      if (!items.length) return;
      var original = reorderBtn.textContent;
      reorderBtn.disabled = true;
      reorderBtn.textContent = 'Adding…';
      reorderItems(items).catch(function (err) {
        alert(err.message);
        reorderBtn.disabled = false;
        reorderBtn.textContent = original;
      });
      return;
    }

    var toggle = e.target.closest('[data-cart-toggle]');
    if (toggle) {
      e.preventDefault();
      var drawer = document.querySelector('[data-cart-drawer]');
      if (drawer && drawer.classList.contains('is-open')) closeDrawer();
      else openDrawer();
      return;
    }

    var qtyBtn = e.target.closest('[data-cart-qty-change]');
    if (qtyBtn) {
      e.preventDefault();
      var key = qtyBtn.getAttribute('data-cart-qty-change');
      var delta = parseInt(qtyBtn.getAttribute('data-delta'), 10);
      var span = qtyBtn.parentElement.querySelector('span');
      var current = span ? parseInt(span.textContent, 10) : 1;
      changeLineQty(key, Math.max(0, current + delta));
      return;
    }

    var removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn) {
      e.preventDefault();
      changeLineQty(removeBtn.getAttribute('data-cart-remove'), 0);
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var variantInput = form.querySelector('[name="id"]');
    if (!variantInput || !variantInput.value) return;
    var qtyInput = form.querySelector('[name="quantity"]');
    var quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    var submitBtn = form.querySelector('[type="submit"]');
    var originalText = submitBtn ? submitBtn.textContent : '';
    if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Adding…'; }
    addToCart(variantInput.value, quantity)
      .then(function () {
        if (submitBtn) { submitBtn.textContent = 'Added to cart'; }
      })
      .catch(function (err) {
        if (submitBtn) { submitBtn.textContent = originalText; }
        alert(err.message);
      })
      .finally(function () {
        if (submitBtn) {
          setTimeout(function () {
            submitBtn.disabled = false;
            submitBtn.textContent = originalText;
          }, 1800);
        }
      });
  });

  updateCartCount();

  /* ---------------- Product variant picker ---------------- */

  document.querySelectorAll('[data-variant-picker]').forEach(function (root) {
    var variantsJson = root.querySelector('[data-variants-json]');
    if (!variantsJson) return;
    var variants = JSON.parse(variantsJson.textContent);
    var selects = root.querySelectorAll('[data-option-group]');
    var idInput = root.querySelector('[name="id"]');
    var priceEl = root.querySelector('[data-price]');
    var stockEl = root.querySelector('[data-stock-note]');
    var addBtn = root.querySelector('[data-add-btn]');
    var soldoutBlock = root.querySelector('[data-soldout-block]');
    var buyBlock = root.querySelector('[data-buy-block]');

    function currentSelection() {
      var opts = [];
      selects.forEach(function (group) {
        var active = group.querySelector('.is-active');
        opts.push(active ? active.getAttribute('data-value') : null);
      });
      return opts;
    }

    function findVariant() {
      var sel = currentSelection();
      return variants.filter(function (v) {
        return v.options.every(function (val, i) { return sel[i] === null || val === sel[i]; });
      })[0];
    }

    function render() {
      var variant = findVariant();
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = variant.price_formatted + ' ';

      var available = variant.available;
      var low = available && variant.inventory_quantity !== null && variant.inventory_quantity > 0 && variant.inventory_quantity <= 2;

      if (buyBlock) buyBlock.style.display = available ? '' : 'none';
      if (soldoutBlock) soldoutBlock.style.display = available ? 'none' : '';
      if (stockEl) {
        if (low) {
          stockEl.style.display = '';
          stockEl.textContent = 'Only ' + variant.inventory_quantity + ' left at this size.';
        } else {
          stockEl.style.display = 'none';
        }
      }
      if (addBtn && available) {
        addBtn.textContent = 'Add to cart — ' + variant.price_formatted;
      }

      root.querySelectorAll('[data-media-for-variant]').forEach(function (img) {
        img.style.display = img.getAttribute('data-media-for-variant') === String(variant.featured_media_id) ? '' : 'none';
      });
    }

    root.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-option-group] button');
      if (!opt) return;
      var group = opt.closest('[data-option-group]');
      group.querySelectorAll('button').forEach(function (b) { b.classList.remove('is-active'); });
      opt.classList.add('is-active');
      render();
    });

    render();
  });

  /* ---------------- Gallery thumbnails ---------------- */

  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main] img');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        var full = thumb.getAttribute('data-full');
        if (main && full) main.src = full;
      });
    });
  });

  /* ---------------- Collection density toggle ---------------- */

  document.querySelectorAll('[data-density-toggle]').forEach(function (root) {
    var grids = document.querySelectorAll('[data-product-grid]');
    var stored = window.localStorage ? window.localStorage.getItem('llstudios-density') : null;
    if (stored) applyDensity(stored);

    root.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var density = btn.getAttribute('data-density');
        applyDensity(density);
        if (window.localStorage) window.localStorage.setItem('llstudios-density', density);
      });
    });

    function applyDensity(density) {
      root.querySelectorAll('button').forEach(function (b) {
        b.classList.toggle('is-active', b.getAttribute('data-density') === density);
      });
      grids.forEach(function (grid) { grid.classList.toggle('product-grid--dense', density === 'dense'); });
    }
  });

  /* ---------------- Shop grid: search, facets, sort ---------------- */

  document.querySelectorAll('[data-shop-root]').forEach(function (root) {
    var searchInput = root.querySelector('[data-shop-search]');
    var sortSelect = root.querySelector('[data-shop-sort]');
    var resultEl = root.querySelector('[data-shop-result]');
    var emptyEl = root.querySelector('[data-shop-empty]');
    var bands = root.querySelectorAll('[data-designer-band]');
    var totalCount = root.querySelectorAll('[data-product-item]').length;

    var state = { query: '', theme: [], designer: [], mesh: [], priceMin: null, priceMax: null };

    function toggleMulti(arr, val) {
      var i = arr.indexOf(val);
      if (i > -1) arr.splice(i, 1); else arr.push(val);
    }

    function bindChip(key) {
      return function (btn) {
        btn.addEventListener('click', function () {
          toggleMulti(state[key], btn.getAttribute('data-facet-value'));
          btn.classList.toggle('is-active');
          apply();
        });
      };
    }

    root.querySelectorAll('[data-facet="theme"] [data-facet-value]').forEach(bindChip('theme'));
    root.querySelectorAll('[data-facet="designer"] [data-facet-value]').forEach(bindChip('designer'));
    root.querySelectorAll('[data-facet="mesh"] [data-facet-value]').forEach(bindChip('mesh'));

    root.querySelectorAll('[data-facet="price"] [data-facet-min]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var already = btn.classList.contains('is-active');
        root.querySelectorAll('[data-facet="price"] [data-facet-min]').forEach(function (b) { b.classList.remove('is-active'); });
        if (already) {
          state.priceMin = null; state.priceMax = null;
        } else {
          btn.classList.add('is-active');
          state.priceMin = parseFloat(btn.getAttribute('data-facet-min'));
          state.priceMax = parseFloat(btn.getAttribute('data-facet-max'));
        }
        apply();
      });
    });

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        state.query = searchInput.value.trim().toLowerCase();
        apply();
      });
    }
    if (sortSelect) sortSelect.addEventListener('change', apply);

    root.querySelectorAll('[data-shop-clear], [data-shop-clear-2]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state = { query: '', theme: [], designer: [], mesh: [], priceMin: null, priceMax: null };
        if (searchInput) searchInput.value = '';
        root.querySelectorAll('.chip.is-active').forEach(function (c) { c.classList.remove('is-active'); });
        apply();
      });
    });

    function matches(item) {
      var theme = (item.getAttribute('data-theme') || '').split(',');
      var designer = item.getAttribute('data-designer') || '';
      var mesh = (item.getAttribute('data-mesh') || '').split(',');
      var name = (item.getAttribute('data-name') || '').toLowerCase();
      var price = parseFloat(item.getAttribute('data-price') || '0');

      if (state.query && name.indexOf(state.query) === -1) return false;
      if (state.theme.length && !state.theme.some(function (t) { return theme.indexOf(t) > -1; })) return false;
      if (state.designer.length && state.designer.indexOf(designer) === -1) return false;
      if (state.mesh.length && !state.mesh.some(function (m) { return mesh.indexOf(m) > -1; })) return false;
      if (state.priceMin !== null && !(price >= state.priceMin && price <= state.priceMax)) return false;
      return true;
    }

    function sortItems(grid) {
      if (!grid) return;
      var sort = sortSelect ? sortSelect.value : 'new';
      var arr = Array.prototype.slice.call(grid.querySelectorAll('[data-product-item]'));
      arr.sort(function (a, b) {
        if (sort === 'low') return parseFloat(a.dataset.price) - parseFloat(b.dataset.price);
        if (sort === 'high') return parseFloat(b.dataset.price) - parseFloat(a.dataset.price);
        if (sort === 'az') return a.dataset.name.localeCompare(b.dataset.name);
        return parseInt(b.dataset.created, 10) - parseInt(a.dataset.created, 10);
      });
      arr.forEach(function (el) { grid.appendChild(el); });
    }

    function apply() {
      var visibleCount = 0;
      bands.forEach(function (band) {
        var bandItems = band.querySelectorAll('[data-product-item]');
        var bandVisible = 0;
        bandItems.forEach(function (item) {
          var ok = matches(item);
          item.style.display = ok ? '' : 'none';
          if (ok) { bandVisible++; visibleCount++; }
        });
        band.style.display = bandVisible ? '' : 'none';
        if (bandVisible) sortItems(band.querySelector('[data-product-grid]'));
      });

      var anyFilter = !!(state.query || state.theme.length || state.designer.length || state.mesh.length || state.priceMin !== null);
      var clearBtn = root.querySelector('[data-shop-clear]');
      if (clearBtn) clearBtn.style.display = anyFilter ? '' : 'none';

      if (resultEl) {
        resultEl.textContent = !anyFilter
          ? ('All ' + totalCount + ' canvases, grouped by designer')
          : (visibleCount + (visibleCount === 1 ? ' canvas' : ' canvases') + ' match');
      }
      if (emptyEl) emptyEl.style.display = visibleCount === 0 ? '' : 'none';
    }

    apply();
  });

  /* ---------------- Favorites (wishlist) ---------------- */

  function getFavs() {
    try { return JSON.parse(window.localStorage.getItem('llstudios-favs') || '[]'); }
    catch (e) { return []; }
  }
  function setFavs(list) {
    try { window.localStorage.setItem('llstudios-favs', JSON.stringify(list)); } catch (e) { /* noop */ }
  }
  function paintFavs() {
    var favs = getFavs();
    document.querySelectorAll('[data-fav-toggle]').forEach(function (btn) {
      var id = btn.getAttribute('data-fav-toggle');
      var active = favs.indexOf(id) > -1;
      btn.classList.toggle('is-active', active);
      btn.textContent = active ? '♥' : '♡';
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-fav-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var id = btn.getAttribute('data-fav-toggle');
    var favs = getFavs();
    var idx = favs.indexOf(id);
    if (idx > -1) favs.splice(idx, 1); else favs.push(id);
    setFavs(favs);
    paintFavs();
  });
  paintFavs();
})();
